const cartResources = {
  en: {
    translation: {
      'Cart title': 'Why customers trust',
      'Cart1 title': 'The Expert Team',
      'Cart1 text':
        'Insurance with the best - entrust your protection to real experts.',
      'Cart2 title': 'Personal approach',
      'Cart2 text':
        'The ability to settle losses out of court and conduct independent expertise.',
      'Cart3 title': 'More than 700,000',
      'Cart3 text': 'Customers trust us at the moment',
      'Cart4 title': 'Always there for you',
      'Cart4 text':
        'Our emergency commissioners are ready to help you in all cities and regions of Kazakhstan.',
      TestimonialsTitle: 'Reviews from our customers',
      Testimonials2GIS: 'Review from 2GIS',
      TestimonialsGoogle: 'Review from Google Maps',
    },
  },
  kz: {
    translation: {
      'Cart title': 'Клиенттер неліктен',
      'Cart1 title': 'Сарапшылар Тобы',
      'Cart1 text':
        'Ең жақсы сақтандыру - қорғауды нағыз сарапшыларға тапсырыңыз.',
      'Cart2 title': 'Жеке көзқарас',
      'Cart2 text':
        'Залалдарды соттан тыс реттеу және тәуелсіз сараптама жүргізу мүмкіндігі.',
      'Cart3 title': '700 000 астам клиент',
      'Cart3 text': 'Қазіргі уақытта бізге сенімдерін артады',
      'Cart4 title': 'Әрдайым жаныңызда',
      'Cart4 text':
        'Біздің апаттық комиссарларымыз Сіздерге Қазақстанның барлық қалалары мен  өңірлерінде көмектесуге дайын.',
      TestimonialsTitle: 'Біздің клиенттердің пікірлері',
      Testimonials2GIS: 'Пікір 2GIS-тен',
      TestimonialsGoogle: 'Пікір Google Maps-тан',
    },
  },
  ru: {
    translation: {
      'Cart title': 'Почему клиенты доверяют',
      'Cart1 title': 'Команда Экспертов',
      'Cart1 text':
        'Страхование с лучшими - доверьте вашу защиту настоящим экспертам.',
      'Cart2 title': 'Персональный подход',
      'Cart2 text':
        'Возможность внесудебно урегулировать убытки и провести независимую экспертизу.',
      'Cart3 title': 'Более 700 000 клиентов',
      'Cart3 text': 'Доверяют нам на данный момент',
      'Cart4 title': 'Всегда рядом',
      'Cart4 text':
        'Наши аварийные комиссары готовы помочь Вам во всех городах и регионах Казахстана.',
      TestimonialsTitle: 'Отзывы наших клиентов',
      Testimonials2GIS: 'Отзыв из 2ГИС',
      TestimonialsGoogle: 'Отзыв из Google Maps',
    },
  },
};

export default cartResources;
